/**
 * API base path — RELATIVE, same-origin, by construction.
 *
 * The SPA and the API are served from one origin (Caddy routes /api, /admin,
 * /media and /static/admin to Django, everything else to the SPA), so the
 * deployment can move between domains (mdc-app.nuagent.net → ats.mdc-sa.com)
 * without a rebuild. Never turn this into an absolute URL or a build arg.
 *
 * Local dev: CRA's setupProxy.js forwards /api and /media to :8000.
 */
export const API_BASE_URL = '/api';
